'use client'

import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/useOnlineStatus'

/**
 * Global banner displayed when the user is offline.
 *
 * Features:
 * - Fixed position at top of viewport
 * - Uses navigator.onLine and online/offline events
 * - Persists until connection is restored (no dismiss button)
 * - Accessible with role="alert"
 */
export function OfflineBanner() {
  const isOnline = useOnlineStatus()

  if (isOnline) {
    return null
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 px-4 py-2 shadow-md"
    >
      <div className="container mx-auto flex items-center justify-center gap-2 text-sm font-medium">
        <WifiOff className="h-4 w-4" />
        <span>No internet connection. Some features may not work properly.</span>
      </div>
    </div>
  )
}
